<!--
  This is a temporary component to display the benchmark image items in a test page.
-->
<template>
  <div v-if="items && items.length > 0">
    <div v-for="item in items" :key="item.imageName">
      <sc-text :field="item.imageName" />
      <sc-text :field="item.locationUrl" />
      <sc-text :field="item.cloudProvider" />
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Benchmark-Image',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text
  }
};
</script>
